const randomStrings = [
    "Gentle breeze rustles leaves",
    "Sparkling stars illuminate night sky",
    "Rapid river flows endlessly",
    "Whispering winds carry secrets afar",
    "Golden sunlight bathes meadows",
    "Silent footsteps echo in darkness",
    "Tranquil lake reflects mountain peaks",
    "Dancing flames warm chilly evening",
    "Majestic eagle soars high above",
    "Soothing rain quenches parched earth",
    "Vibrant flowers bloom in spring",
    "Echoing laughter fills the room",
    "Harmonious melodies soothe the soul",
    "Luminous moonlight casts shadows",
    "Infinite possibilities await exploration",
    "Serenading birds greet dawns arrival",
    "Whirling dervishes spin in ecstasy",
    "Whimsical butterflies flutter gracefully",
    "Enchanting forest beckons adventurers forth",
    "Starry eyed lovers embrace beneath moonlight",
    "Salty waves crash against rugged cliffs",
    "Mystical fog shrouds ancient ruins",
    "Wisps of fog dance among trees",
    "Spiraling galaxies twinkle in vastness",
    "Ethereal mist blankets morning meadow",
    "Laughter echoes through the canyon",
    "Boundless horizon stretches before us",
    "Jubilant children play in sun drenched fields",
    "Mysterious shadows lurk in the night",
    "Endless possibilities await those who seek",
    "Whispers of the past linger in the air",
    "Cascading waterfall sings nature's song",
    "Gentle raindrops kiss the earth",
    "Majestic mountains tower above the clouds",
    "Lost souls wander aimlessly in the dark",
    "Dreamy clouds drift lazily across the sky",
    "Adventurous spirits roam untamed wilderness",
    "Spirited horses gallop across open plains",
    "Enchanted forests hold secrets untold",
    "Soothing waves lull weary travelers to sleep",
    "Golden sunsets paint the sky with hues",
    "Radiant sunflowers bask in sunlight",
    "Whistling wind whispers tales of old",
    "Glistening dewdrops adorn morning grass",
    "Glimmering stars twinkle in midnight sky",
    "Echoes of laughter linger in the air",
    "Tranquil streams meander through lush valleys",
    "Shimmering lakes mirror azure skies",
    "Infinite possibilities unfold before us",
];

const stringKeys = [
    "apple",
    "banana",
    "orange",
    "tree",
    "mountain",
    "river",
    "ocean",
    "bird",
    "dog",
    "cat",
    "book",
    "computer",
    "chair",
    "table",
    "lamp",
    "sun",
    "moon",
    "star",
    "flower",
    "garden",
    "house",
    "car",
    "bicycle",
    "music",
    "dance",
    "painting",
    "artist",
    "writer",
    "poem",
    "friend",
    "family",
    "love",
    "peace",
    "hope",
    "dream",
    "laughter",
    "smile",
    "joy",
    "happiness",
    "journey",
    "adventure",
    "discovery",
    "knowledge",
    "wisdom",
    "freedom",
    "justice",
    "kindness",
    "compassion"
];

const inverseKeys = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47, 49, 51, 53, 55, 57, 59, 61, 63, 65, 67, 69, 71, 73, 75, 77, 79, 81, 83, 85, 87, 89, 91, 93, 95, 97, 99];

const keyedCipherKeys = [
    "1034", "71398", "582", "9127", "651",
    "347", "8295", "1746", "503", "9238",
    "615", "4832", "275", "8491", "632",
    "921", "735", "408", "2657", "194",
    "372", "598", "816", "305", "2796",
    "4621", "387", "7296", "145", "809"
];

export { randomStrings, inverseKeys, stringKeys, keyedCipherKeys };
